import {RefObject, useCallback} from "react";

import {IComparisonTableScrollDirection} from "../types/IComparisonTableScrollDirection";

interface IProps {
    tableRef: RefObject<HTMLElement | null>;
    headerRef: RefObject<HTMLElement | null>;
    tableRowsRef: RefObject<HTMLElement | null>;
}

const SCROLL_DURATION = 500;
const SCROLL_SAFETY_VALUE = 0.1;

export const useScrollNavigation = (props: IProps) => {
    const smoothScroll = (container: HTMLElement, startPosition: number, targetPosition: number, duration: number) => {
        const distance: number = targetPosition - startPosition;
        let startTime: number | null = null;

        function animation(currentTime: number): void {
            if (startTime === null) {
                startTime = currentTime;
            }
            const timeElapsed: number = currentTime - startTime;
            container.scrollLeft = ease(timeElapsed, startPosition, distance, duration);

            if (timeElapsed < duration) {
                requestAnimationFrame(animation);
            }
        }

        function ease(t: number, b: number, c: number, d: number): number {
            t /= d / 2;
            if (t < 1) {
                return (c / 2) * t * t + b;
            }
            t--;
            return (-c / 2) * (t * (t - 2) - 1) + b;
        }

        requestAnimationFrame(animation);
    };

    const getScrollStep = (tableRows: HTMLElement) => {
        const firstRow = tableRows.firstElementChild as HTMLElement | null;
        const rowChildren = firstRow?.children;
        // First element is row header; first data cell starts at index 1.
        const dataCell = (rowChildren?.[1] ?? firstRow?.lastElementChild) as HTMLElement | undefined;

        if (!dataCell) {
            return null;
        }

        const cellStyles = getComputedStyle(dataCell);
        const marginRight = parseFloat(cellStyles.marginRight) || 0;
        const rowStyles = firstRow ? getComputedStyle(firstRow) : null;
        // Fallback in case spacing is implemented via CSS gap instead of margin-right.
        const rowGap = rowStyles ? parseFloat(rowStyles.columnGap || rowStyles.gap) || 0 : 0;
        const gap = marginRight > 0 ? marginRight : rowGap;

        return dataCell.offsetWidth + gap;
    };

    const smoothScrollSync = (tableContent: HTMLElement, headerContent: HTMLElement, left: number) => {
        smoothScroll(tableContent, tableContent.scrollLeft, tableContent.scrollLeft + left, SCROLL_DURATION);
        smoothScroll(headerContent, tableContent.scrollLeft, tableContent.scrollLeft + left, SCROLL_DURATION);
    };

    const tableScroll = useCallback(
        (scrollDirection: IComparisonTableScrollDirection) => {
            const headerContent = props.headerRef.current;
            const tableContent = props.tableRef.current;
            const tableRows = props.tableRowsRef.current;

            if (tableContent && tableRows && headerContent) {
                /*
                 * NOTE: We need to add small value to `scrollBy` value. CSS `calc` function may return decimal pixels value
                 * for example `187.78` (for CSS this will be a correct value), but DOM element `offsetWidth` will round this
                 * to the nearest full number. For us this small difference will break table scroll. Adding `scrollSafetyValue`
                 * will mitigate this problem.
                 */
                const scrollBy = getScrollStep(tableRows);

                if (scrollBy == null) {
                    return;
                }

                const left = scrollDirection === IComparisonTableScrollDirection.RIGHT ? scrollBy + SCROLL_SAFETY_VALUE : -scrollBy - SCROLL_SAFETY_VALUE;

                smoothScrollSync(tableContent, headerContent, left);
            }
        },
        [props.headerRef, props.tableRef, props.tableRowsRef]
    );

    const tableScrollToSpecificValue = useCallback(
        (left: number, shouldBeSmooth = true) => {
            const headerContent = props.headerRef.current;
            const tableContent = props.tableRef.current;

            if (tableContent && headerContent) {
                if (shouldBeSmooth) {
                    smoothScrollSync(tableContent, headerContent, left);
                } else {
                    tableContent.scrollLeft = left;
                    headerContent.scrollLeft = left;
                }
            }
        },
        [props.headerRef, props.tableRef]
    );

    return {
        tableScroll,
        tableScrollToSpecificValue
    };
};
import {RefObject, useCallback} from "react";

import {IComparisonTableScrollDirection} from "../types/IComparisonTableScrollDirection";

interface IProps {
    tableRef: RefObject<HTMLElement | null>;
    headerRef: RefObject<HTMLElement | null>;
    tableRowsRef: RefObject<HTMLElement | null>;
}

const SCROLL_DURATION = 500;
const SCROLL_SAFETY_VALUE = 0.1;

export const useScrollNavigation = (props: IProps) => {
    const smoothScroll = (container: HTMLElement, startPosition: number, targetPosition: number, duration: number) => {
        const distance: number = targetPosition - startPosition;
        let startTime: number | null = null;

        function animation(currentTime: number): void {
            if (startTime === null) {
                startTime = currentTime;
            }
            const timeElapsed: number = currentTime - startTime;
            container.scrollLeft = ease(timeElapsed, startPosition, distance, duration);

            if (timeElapsed < duration) {
                requestAnimationFrame(animation);
            }
        }

        function ease(t: number, b: number, c: number, d: number): number {
            t /= d / 2;
            if (t < 1) {
                return (c / 2) * t * t + b;
            }
            t--;
            return (-c / 2) * (t * (t - 2) - 1) + b;
        }

        requestAnimationFrame(animation);
    };

    const getScrollStep = (tableRows: HTMLElement) => {
        const firstRow = tableRows.firstElementChild as HTMLElement | null;
        const rowChildren = firstRow?.children;
        // First element is row header; first data cell starts at index 1.
        const dataCell = (rowChildren?.[1] ?? firstRow?.lastElementChild) as HTMLElement | undefined;

        if (!dataCell) {
            return null;
        }

        const cellStyles = getComputedStyle(dataCell);
        const marginRight = parseFloat(cellStyles.marginRight) || 0;
        const rowStyles = firstRow ? getComputedStyle(firstRow) : null;
        // Fallback in case spacing is implemented via CSS gap instead of margin-right.
        const rowGap = rowStyles ? parseFloat(rowStyles.columnGap || rowStyles.gap) || 0 : 0;
        const gap = marginRight > 0 ? marginRight : rowGap;

        return dataCell.offsetWidth + gap;
    };

    const smoothScrollSync = (tableContent: HTMLElement, headerContent: HTMLElement, left: number) => {
        smoothScroll(tableContent, tableContent.scrollLeft, tableContent.scrollLeft + left, SCROLL_DURATION);
        smoothScroll(headerContent, tableContent.scrollLeft, tableContent.scrollLeft + left, SCROLL_DURATION);
    };

    const tableScroll = useCallback(
        (scrollDirection: IComparisonTableScrollDirection) => {
            const headerContent = props.headerRef.current;
            const tableContent = props.tableRef.current;
            const tableRows = props.tableRowsRef.current;

            if (tableContent && tableRows && headerContent) {
                /*
                 * NOTE: We need to add small value to `scrollBy` value. CSS `calc` function may return decimal pixels value
                 * for example `187.78` (for CSS this will be a correct value), but DOM element `offsetWidth` will round this
                 * to the nearest full number. For us this small difference will break table scroll. Adding `scrollSafetyValue`
                 * will mitigate this problem.
                 */
                const scrollBy = getScrollStep(tableRows);

                if (scrollBy == null) {
                    return;
                }

                const left = scrollDirection === IComparisonTableScrollDirection.RIGHT ? scrollBy + SCROLL_SAFETY_VALUE : -scrollBy - SCROLL_SAFETY_VALUE;

                smoothScrollSync(tableContent, headerContent, left);
            }
        },
        [props.headerRef, props.tableRef, props.tableRowsRef]
    );

    const tableScrollToSpecificValue = useCallback(
        (left: number, shouldBeSmooth = true) => {
            const headerContent = props.headerRef.current;
            const tableContent = props.tableRef.current;

            if (tableContent && headerContent) {
                if (shouldBeSmooth) {
                    smoothScrollSync(tableContent, headerContent, left);
                } else {
                    tableContent.scrollLeft = left;
                    headerContent.scrollLeft = left;
                }
            }
        },
        [props.headerRef, props.tableRef]
    );

    return {
        tableScroll,
        tableScrollToSpecificValue
    };
};
